/* generated from backend OpenAPI -- do not edit */
import type { JSONSchema } from 'zod/v4/core';
export const schema = {
  "type": "object",
  "properties": {
    "id": {
      "type": "string",
      "minLength": 1
    },
    "senderName": {
      "type": "string",
      "maxLength": 160
    },
    "channel": {
      "type": "string",
      "enum": [
        "whatsapp",
        "email",
        "sms"
      ]
    },
    "createdAt": {
      "type": "string",
      "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$"
    },
    "kind": {
      "type": "string",
      "enum": [
        "text",
        "image",
        "video",
        "audio",
        "file"
      ]
    },
    "propertyId": {
      "type": "integer",
      "exclusiveMinimum": true,
      "maximum": 9007199254740991,
      "minimum": 0
    },
    "property": {
      "type": "object",
      "properties": {
        "propertyType": {
          "nullable": true,
          "type": "string",
          "enum": [
            "HOUSE",
            "APARTMENT",
            "OFFICE",
            "RETAIL",
            "WAREHOUSE",
            "LAND",
            "PARCEL",
            "PARKING",
            "INDUSTRIAL",
            "OTHER"
          ]
        },
        "propertySubtype": {
          "nullable": true,
          "type": "string",
          "enum": [
            "STUDIO"
          ]
        },
        "locality": {
          "nullable": true,
          "type": "string"
        },
        "operation": {
          "nullable": true,
          "type": "string",
          "enum": [
            "SALE",
            "RENT",
            "SALE_AND_RENT",
            "TEMPORARY_RENT"
          ]
        },
        "salePriceAmount": {
          "nullable": true,
          "type": "string"
        },
        "salePriceCurrency": {
          "nullable": true,
          "type": "string"
        },
        "rentPriceAmount": {
          "nullable": true,
          "type": "string"
        },
        "rentPriceCurrency": {
          "nullable": true,
          "type": "string"
        }
      }
    }
  },
  "required": [
    "id",
    "channel",
    "createdAt",
    "kind"
  ],
  "x-browser-runtime-schema": true
} satisfies JSONSchema.JSONSchema;
